export default {
  namespaced: true,
  state () {
    return {
      stack: []
    }
  },
  getters: {
    isLoading (state) {
      return state.stack.length > 0
    }
  },
  mutations: {
    loading (state) {
      state.stack.push({})
    },
    loaded (state) {
      state.stack.pop()
    }
  },
  actions: {
    startLoading ({ commit }) {
      commit('loading')
    },
    endLoading ({ commit }) {
      commit('loaded')
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/store/loading.js